import { useRef, useState, useEffect } from "react";
import { FiPlus } from "react-icons/fi";

export default function VerifyIdPreview({
    imageFile,
    onReplace,
    onContinue
}) {
    const fileRef = useRef(null);

    const [previewUrl, setPreviewUrl] = useState(null);

    useEffect(() => {
        if (!imageFile) return;

        const url = URL.createObjectURL(imageFile);
        setPreviewUrl(url);

        return () => URL.revokeObjectURL(url);
    }, [imageFile]);

    if (!imageFile) return null;

    const handleReplace = (e) => {
        const file = e.target.files[0];
        if (file && onReplace) {
            onReplace(file);
        }
    };

    return (
        <div className="flex items-center justify-center w-full h-full">

            <div className="flex flex-col items-center text-center px-4">

                {/* Title */}
                <h2 className="text-white text-sm font-semibold mb-1">
                    Verify Your ID
                </h2>
                <p className="text-gray-400 text-xs max-w-xs mb-6">
                    Make sure the front side of your ID and your face are clearly visible.
                </p>

                {/* Uploaded Image */}
                <div className="w-[180px] h-[260px] rounded-2xl overflow-hidden mb-2">
                    <img
                        src={previewUrl}
                        alt="Uploaded"
                        className="w-full h-full object-cover"
                    />
                </div>

                <span className="text-green-400 text-xs mb-6 flex items-center gap-1">
                    ✓ Uploaded Photo
                </span>

                {/* Replace Button */}
                <button
                    onClick={() => fileRef.current.click()}
                    className="w-[260px] flex items-center justify-center gap-2 py-3
                                rounded-full border border-red-500 text-white text-sm
                                transition mb-4"
                >
                    <FiPlus />
                    Replace Photo
                </button>

                <input
                    type="file"
                    accept="image/*"
                    ref={fileRef}
                    onChange={handleReplace}
                    className="hidden"
                />

                {/* Continue Button */}
                <button
                    disabled={!imageFile}
                    onClick={onContinue}
                    className="w-[260px] py-3 rounded-full
                               bg-red-500 text-white text-sm font-medium
                               transition mb-6"
                >
                    Continue
                </button>
            </div>
        </div>
    );
}